import { render, staticRenderFns } from "./Postskeleton.vue?vue&type=template&id=31d203ac&scoped=true"
import script from "./Postskeleton.vue?vue&type=script&lang=js"
export * from "./Postskeleton.vue?vue&type=script&lang=js"
import style0 from "./Postskeleton.vue?vue&type=style&index=0&id=31d203ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d203ac",
  null
  
)

export default component.exports